<template>
    <div class="card card-animated product-card event-product" :class="{ 'active': this.bikeIsInCart(bike.id, typeRental) }">
        <div class="card-body sm-paddings">
            <h5 class="product-title">{{ bike.type_name }}</h5>
            <div class="product-image" :class="{ unavailable: bike.image.image === null }"
                 :style="'background-image: url(' + (bike.image.image ? bike.image.fullImage : './assets/images/icons/no-image.png') + ')'">
<!--                <img :src="bike.image.image ? bike.image.fullImage : '/assets/images/icons/no-image.png'" :alt="bike.type_name">-->
            </div>
            <div class="product-pricing-grid" v-if="tableTimeOptions.length">
                <table>
                    <thead>
                    <tr>
                        <th></th>
                        <th v-for="o in tableTimeOptions" :key="o">{{ o | filterTimeOptionShortTitle }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="price-walk-in">
                        <td>Walk-In</td>
                        <td v-for="o in tableTimeOptions" :key="o">{{ (getTimeOptionById(o).price || 'N/A')  | filterPrice(0) }}</td>
                    </tr>
                    <tr class="price-online">
                        <td>Online</td>
                        <td v-for="o in tableTimeOptions" :key="o">{{ (getTimeOptionById(o).final_price || 'N/A')  | filterPrice }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <ul class="product-attributes">
                <li>
                    <span class="item-title">Available Accessories:</span>
                    <span class="item-value">{{ accessories ? 'Yes' : 'No' }}</span>
                </li>
            </ul>
            <div class="d-flex justify-content-between mt-4 mb-3">
                <div class="product-price compact d-flex flex-column">
                    <template v-if="bike.discount > 0">
                        <span class="old-price">{{ currentTimeOption.price | filterPrice(0) }}</span>
                        <span class="new-price">{{ currentTimeOption.final_price | filterPrice(2) }}</span>
                        <span class="duration">{{ timeOption.id | filterTimeOptionShortTitle(false) }}</span>
                    </template>
                    <template v-else>
                        <span class="new-price">{{ currentTimeOption.price | filterPrice(0) }}</span>
                        <span class="duration">{{ timeOption.id | filterTimeOptionShortTitle(false) }}</span>
                    </template>
                </div>
                <div class="amount-selector flex-shrink-0">
                    <NumberSelector v-model="itemsCount" item-title="bike"/>
                </div>
            </div>
            <a href="javascript:void(0);" class="btn btn-primary w-100" :class="{'disabled': itemsCount <= 0}" @click="addToCart()">
                Add to basket <span v-if="itemsCount > 0">- {{ currentTimeOption.final_price * itemsCount | filterPrice }}</span>
            </a>

        </div>

    </div>
</template>

<script>
import NumberSelector from "../elements/NumberSelector";
import {mapActions, mapGetters} from "vuex";
import EventItem from "../../../models/EventItem";
import BikeItem from "../../../models/BikeItem";
import FareHarborMixin from "../../../mixins/FareHarborMixin";
export default {
    name: "ProductDetailedCard",
    mixins: [FareHarborMixin],
    components: {NumberSelector},
    props: {
        bike: {
            required: true
        },
        accessories: {
            type: Boolean,
            default: true
        },
        timeOption: {
            type: Object,
        },
        typeRental: {
            type: String,
            default: 'rentals'
        },
        pageSlug: {
            type: String,
            default: 'rental'
        }
    },
    data: function () {
        return {
            itemsCount: 0
        }
    },
    computed: {
        ...mapGetters('cart', ['bikeIsInCart']),
        currentTimeOption: function() {

            if(this.typeRental === 'events') {
                return this.bike.event_time_option_price.find(o => o.price_id === this.timeOption.id)
            }

            return this.bike.time_options_price.find(o => o.price_id === this.timeOption.id)
        },
        tableTimeOptions() {

            if(this.typeRental === 'events') {
                return JSON.parse(this.$eventTableTimeOptions);
            }

            return JSON.parse(this.$mixTableTimeOptions);
        }
    },
    methods: {
        ...mapActions('cart', ['addBike', 'addEvent']),
        getTimeOptionById(id) {

            if(this.typeRental === 'events') {
                return this.bike.event_time_option_price.find(i => i.price_id === id) || {};
            }

            return this.bike.time_options_price.find(i => i.price_id === id) || {};
        },
        wellDoneNotify() {
            this.$notify({
                title: 'Well done!',
                text: '«' + this.bike.type_name + '» was added to cart successfully!',
                duration: 2000
            });
        },
        oopsNotify() {
            this.$notify({
                title: 'Oops!',
                text: 'Can\'t add this bike, because there is tour in cart!'
            });
        },
        promoRemoveNotify() {
            this.$notify({
                title: 'Promo-code was removed!',
                text: 'Discounted bikes can\'t be used with promo-codes!'
            });
        },
        addToCart() {
            if (this.fareHarborMode() && this.typeRental === 'rentals') return this.openFareHarborModal();

            if (this.typeRental === 'events') {
                this.addEvent(new EventItem(this.bike, this.itemsCount, this.currentTimeOption)).then(res => {
                    switch (res) {
                        case 0:
                            this.wellDoneNotify();
                            return;
                        case 1:
                            this.oopsNotify();
                            return;
                        case 2:
                            this.promoRemoveNotify();
                            return;
                    }
                });
            } else {
                this.addBike(new BikeItem(this.bike, this.itemsCount, this.currentTimeOption)).then(res => {
                    switch (res) {
                        case 0:
                            this.wellDoneNotify();
                            return;
                        case 1:
                            this.oopsNotify();
                            return;
                        case 2:
                            this.promoRemoveNotify();
                            return;
                    }
                });
            }
            this.itemsCount = 0;
        }
    }
}
</script>

<style scoped>

</style>
